module.exports = __webpack_public_path__ + "static/media/Phenikaa_Chermical.6606a862.jpg";